<template>
  <div>
    <loading :active.sync="isLoading"
             :can-cancel="false"
             :is-full-page="true"></loading>
    <div class="row">
      <div class="col-sm-10 offset-sm-1">
        <div class="row mt-4">
          <div class="col-sm-8">
            <h2>{{ $t('SELL_VEHICLE_TITLE') }}</h2>
            <p class="card-subtitle">{{ $t('SELL_VEHICLE_SUBTITLE') }}</p>
          </div>
          <div class="col-sm-4 text-right">
            <img src="../assets/lang/german.png" alt="Deutsch" @click="changeLanguage('de')" class="cursor">
            &nbsp;
            <img src="../assets/lang/french.png" alt="Francais" @click="changeLanguage('fr')" class="cursor">
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-sm-12">
            <b-card>
              <form @submit.prevent="sendForm">
                <!-- Marque -->
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-group :label="$t('FORM_MAKE_LABEL')" label-for="make">
                      <b-form-input id="make" type="text" v-model="form.make" required :placeholder="$t('FORM_MAKE_PLACEHOLDER')"></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-6">
                    <b-form-group :label="$t('FORM_MODEL_LABEL')" label-for="model">
                      <b-form-input id="model" type="text" v-model="form.model" required :placeholder="$t('FORM_MODEL_PLACEHOLDER')"></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6">
                    <b-form-group :label="$t('FORM_YEAR_LABEL')" label-for="year">
                      <b-form-input id="year" type="text" v-model="form.year" required :placeholder="$t('FORM_YEAR_PLACEHOLDER')"></b-form-input>
                    </b-form-group>
                  </div>

                  <div class="col-sm-6">
                    <b-form-group :label="$t('FORM_KILOMETERS_LABEL')" label-for="kilometers">
                      <b-form-input id="kilometers" type="text" v-model="form.kilometers" required
                                    :placeholder="$t('FORM_KILOMETERS_PLACEHOLDER')"></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <b-form-group :label="$t('FORM_CAR_LABEL')">
                      <b-form-radio-group id="type" v-model="form.type">
                        <b-form-radio value="cabrio">Cabrio</b-form-radio>
                        <b-form-radio value="limousine">Limousine</b-form-radio>
                        <b-form-radio value="utility">Utility</b-form-radio>
                        <b-form-radio value="break">Break</b-form-radio>
                        <b-form-radio value="suv">SUV</b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <b-form-group :label="$t('FORM_OPTIONS_LABEL')">
                      <div class="row">
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.leather" :value="$t('OPTIONS.FORM_LEATHER_LABEL')">{{
                              $t('OPTIONS.FORM_LEATHER_LABEL')
                            }}
                          </b-form-checkbox>
                        </div>
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.led" :value="$t('OPTIONS.FORM_LED_LABEL')">{{ $t('OPTIONS.FORM_LED_LABEL') }}</b-form-checkbox>
                        </div>
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.air_conditioner" :value="$t('OPTIONS.FORM_AIR_CONDITIONING_LABEL')">
                            {{ $t('OPTIONS.FORM_AIR_CONDITIONING_LABEL') }}
                          </b-form-checkbox>
                        </div>
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.central_lock" :value="$t('OPTIONS.FORM_CENTRAL_LOCK_LABEL')">
                            {{ $t('OPTIONS.FORM_CENTRAL_LOCK_LABEL') }}
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.gps" :value="$t('OPTIONS.FORM_GPS_LABEL')">{{ $t('OPTIONS.FORM_GPS_LABEL') }}</b-form-checkbox>
                        </div>
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.multimedia_steering_wheel" :value="$t('OPTIONS.FORM_MULTIFUNCTIONAL_STEERING_WHEEL_LABEL')">
                            {{ $t('OPTIONS.FORM_MULTIFUNCTIONAL_STEERING_WHEEL_LABEL') }}
                          </b-form-checkbox>
                        </div>
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.bluetooth" :value="$t('OPTIONS.FORM_BLUETOOTH_LABEL')">{{
                              $t('OPTIONS.FORM_BLUETOOTH_LABEL')
                            }}
                          </b-form-checkbox>
                        </div>
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.parking_aid_back" :value="$t('OPTIONS.FORM_PARKING_AID_BACK_LABEL')">
                            {{ $t('OPTIONS.FORM_PARKING_AID_BACK_LABEL') }}
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.sunroof" :value="$t('OPTIONS.FORM_SUNROOF_LABEL')">{{
                              $t('OPTIONS.FORM_SUNROOF_LABEL')
                            }}
                          </b-form-checkbox>
                        </div>
                        <div class="col-sm-3">
                          <b-form-checkbox v-model="form.extras.hitch" :value="$t('OPTIONS.FORM_HITCH_LABEL')">{{
                              $t('OPTIONS.FORM_HITCH_LABEL')
                            }}
                          </b-form-checkbox>
                        </div>
                      </div>
                      <div class="row mt-3">
                        <div class="col-sm-12">
                          <b-form-group :label="$t('OPTIONS.FORM_OTHER_OPTIONS_LABEL')" label-for="additional_options">
                            <b-form-input id="additional_options" type="text" v-model="form.additional_options"
                                          :placeholder="$t('OPTIONS.FORM_OTHER_OPTIONS_PLACEHOLDER')"></b-form-input>
                          </b-form-group>
                        </div>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-sm-12">
                    <b-form-group :label="$t('DROPZONE_LABEL_FILES_UPLOAD')" label-for="email">
                      <vue-dropzone ref="photoUploadDropzone" id="dropzone" :options="dropzoneOptions" :useCustomSlot='true'
                                    v-on:vdropzone-sending-multiple="dropZoneAdditionalData"
                                    v-on:vdropzone-error="dropZoneErrorEvent"
                                    v-on:vdropzone-success="dropZoneSuccessEvent"
                                    v-on:vdropzone-max-files-exceeded="dropZoneMaxFilesExceeded">
                        <div class="dropzone-custom-content">
                          <h3 class="dropzone-custom-title">{{ $t('DROPZONE_LABEL_HEADER') }}</h3>
                          <!--<div class="subtitle">{{ $t('DROPZONE_LABEL_SUBTITLE') }}</div>-->
                        </div>
                      </vue-dropzone>
                    </b-form-group>
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-group :label="$t('FORM_EMAIL_LABEL')" label-for="email">
                      <b-form-input id="email" type="text" v-model="form.email" required :placeholder="$t('FORM_EMAIL_PLACEHOLDER')"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col-sm-6">
                    <b-form-group :label="$t('FORM_PHONE_LABEL')" label-for="phone">
                      <b-form-input id="phone" type="text" v-model="form.phone" required :placeholder="$t('FORM_PHONE_PLACEHOLDER')"></b-form-input>
                    </b-form-group>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-12">
                    <b-form-checkbox required v-model="form.accept_tos" :value="true" :uncheckedValue="false">
                      {{ $t('FORM_TOS_LABEL') }}
                    </b-form-checkbox>
                  </div>
                </div>

                <div class="row">
                  <div class="col-sm-6 offset-sm-3 text-center">
                    <b-button type="submit" class="mt-4 btn-color-sprintcars" v-if="recaptchaToken !== ''">
                      {{ $t("FORM_SEND_BUTTON_LABEL") }}
                    </b-button>
                  </div>
                </div>

              </form>

            </b-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vue2Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  name: "formContent",
  components: {vueDropzone: vue2Dropzone, Loading},
  data() {
    return {
      isLoading: false,
      form: {
        extras: {},
        accept_tos: false,
        photos: []
      },
      language: "fr",
      recaptchaToken: "",
      dropzoneOptions: {
        url: process.env.VUE_APP_API_URL,
        acceptedFiles: 'image/*',
        maxFilesize: 4,
        paramName: "photos",
        maxFiles: 5,
        addRemoveLinks: true,
        uploadMultiple: true,
        autoProcessQueue: false,
        parallelUploads: 5
      }
    }
  },
  mounted() {
    let vm = this;
    this.$recaptchaLoaded().then(() => {
      this.$recaptcha("sendForm").then(
          (token) => {
            vm.recaptchaToken = token;
            //this.isLoading = false;
          }
      )
    });
  },
  methods: {
    /**
     * @return {boolean}
     */
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },
    dropZoneErrorEvent(file, response) {
      if (this.isJsonString(response)) {
        response = JSON.parse(response);
        this.$swal(this.$t('FORM_SEND_UNSUCCESSFUL'), response.message, "error");
      }
      //this.$refs.photoUploadDropzone.removeAllFiles();

      this.isLoading = false;

      // NEw Recaptcha token
      let vm = this;
      this.$recaptchaLoaded().then(() => {
        this.$recaptcha("sendForm").then(
            (token) => {
              vm.recaptchaToken = token;
              this.isLoading = false;
            }
        )
      });
    },
    // eslint-disable-next-line
    dropZoneSuccessEvent(file, response) {
      let vm = this;
      vm.$swal(vm.$t('FORM_SEND_SUCCESSFUL'), vm.$t('FORM_SEND_SUCCESSFUL_SUB'), "success");
      vm.form = {};
      vm.form.accept_tos = false;
      vm.form.extras = {};
      this.isLoading = false;
      // this.$refs.photoUploadDropzone.removeAllFiles();

      // NEw Recaptcha token
      this.$recaptchaLoaded().then(() => {
        this.$recaptcha("sendForm").then(
            (token) => {
              vm.recaptchaToken = token;
              //this.isLoading = false;
            }
        )
      });
    },
    dropZoneAdditionalData(file, xhr, formData) {
      formData.append("lang", this.language);
      formData.append("form", JSON.stringify(this.form));
      formData.append("recaptchaToken", this.recaptchaToken);
    },
    dropZoneMaxFilesExceeded(file) {
      this.$swal(this.$t("FORM_MAX_FILES_REACHED"), "", "error");
      this.$refs.photoUploadDropzone.removeFile(file);
    },
    changeLanguage($lang) {
      this.$i18n.locale = $lang;
      this.language = $lang;
      this.form.extras = {};
    },
    sendForm() {
      if (this.$refs.photoUploadDropzone.getAcceptedFiles().length > 0) {
        if (!this.form.accept_tos) {
          this.$swal(this.$t('ACCEPT_TOS'), "", "error");
        } else {
          this.$refs.photoUploadDropzone.processQueue();
        }
      } else {
        this.$swal(this.$t('FORM_MINIMUM_1_PHOTO'), "", "error");
      }
    }
  }
}
</script>
